module.exports = "\n\n<select style=\"margin-left:5px;color:#323337 !important;font-weight:normal\">\n  <option value=\"{{ option }}\" ng-repeat=\"option in ctrl.options.popular\">{{ option }}</option>\n  <option value=\"\" disabled>&mdash;&mdash;</option>\n  <option value=\"{{ option }}\" ng-repeat=\"option in ctrl.options.all\">{{ option }}</option>\n</select>\n";


//////////////////
// WEBPACK FOOTER
// ./app/src/common/currency_select/currency_select.html
// module id = 317
// module chunks = 24